import escapeHTML from 'escape-html';
import { ITokenClassKey } from '~/store/games/types';
import { IAllowancePromptConfig } from '~/types/allowances';

export function createGalaSwapAllowancePrompt(
  targetCurrency: ITokenClassKey,
): IAllowancePromptConfig {
  if (!process.env.galaSwapAllowanceGrantee) {
    throw new Error('GALA_SWAP_ALLOWANCE_GRANTEE not known');
  }

  return {
    requesterName: {
      stringKey: 'components.uiComponents.allowanceModal.galaswap',
      args: {},
    },
    requesterUri: 'https://galaswap.gala.com',
    requestTypeName: {
      stringKey: 'components.uiComponents.allowanceModal.tokenAllowanceRequest',
      args: {},
    },
    allowanceTargetIconUri:
      'https://static.gala.games/token-icons/GALA-icon.png', // Only supporting swap allowances from GALA currently
    allowanceTargetName: 'GALA[GalaChain]', // Ditto
    permissionDetailIconUri: require('~/assets/logos/galaswap.svg'),
    permissionDetailTextHtml: {
      stringKey:
        'components.uiComponents.allowanceModal.galaSwapAllowanceRequestDetailHtml',
      args: {
        fromToken: 'GALA[GalaChain]', // Ditto,
        toToken: escapeHTML(targetCurrency.collection + '[GalaChain]'),
      },
    },
    permissionExplanationLinkUri:
      'https://support.gala.com/hc/en-us/articles/22440919500315-Wallet-Allowances',
    permissionExplanationIconType: 'fa-solid fa-book-open',
    permissionExplanationLinkText: {
      stringKey: 'components.uiComponents.allowanceModal.allowanceInfoLinkText',
      args: {},
    },
    allowanceAmount: Number.MAX_SAFE_INTEGER.toString(),
    allowanceType: 5, // swap
    allowanceUses: '1',
    allowanceExpirationMsInFuture: 1000 * 60 * 60 * 24 * 7, // 1 week
    grantee: process.env.galaSwapAllowanceGrantee,
    token: {
      collection: targetCurrency.collection,
      category: targetCurrency.category,
      type: targetCurrency.type,
      additionalKey: targetCurrency.additionalKey,
    },
  };
}
